/* Coach marks: a one-time tip at the moment it matters (first room, first
   door, first furniture). Each shows once per device, never in share view. */
import { $, state } from './state.ts';

const KEY = 'playout:coach';
const TIPS: Record<string, string> = {
  room: 'That’s a room. Type exact inside sizes in the panel, or add a door next — the panel always shows what’s selected.',
  door: 'Drag the door to the side of the wall it should open to. Click the hollow dot on a jamb to move the hinge there.',
  fixture: 'Furniture snaps flush to walls. Hold ⌥ to put it anywhere, press R to rotate, drag a corner to resize.',
};

const seen = (): Record<string, 1> => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; } };
let hideTimer: ReturnType<typeof setTimeout> | null = null;

export function coachShow(step: string): void {
  if (!TIPS[step] || state.shareView) return;
  const done = seen();
  if (done[step]) return;
  done[step] = 1;
  try { localStorage.setItem(KEY, JSON.stringify(done)); } catch { /* private mode: still show once */ }
  const el = $('#coach');
  el.dataset.step = step;
  $('#coachText').textContent = TIPS[step];
  el.classList.add('show');
  if (hideTimer) clearTimeout(hideTimer);
  hideTimer = setTimeout(coachHide, 15000);
}
export function coachHide(): void {
  $('#coach').classList.remove('show');
  if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
}
export function coachReset(): void { try { localStorage.removeItem(KEY); } catch { /* ignore */ } }
